import React from "react";
import NewsletterForm from "./components/NewsletterForm.jsx";
import PrintSubscriptionForm from "./components/PrintSubscriptionForm.jsx";
import "./App.css";

function App() {
    return (
        <>
            <div className="orange-card">
                Subscribe to History: Delivering Princeton to your doorstep for 150 years
            </div>
            <div className="content">
                <div className="subscription-forms">
                    <PrintSubscriptionForm />
                    <NewsletterForm />
                </div>
                <br></br>
            </div>
        </>
    );
}

export default App;
